import { Module } from '../../../ts/Module';
import { CustomizationSettingsCtrl } from '../controllers/CustomizationSettingsCtrl';

Module.instance().directive('tbCustomizationSettingsForm',
  () => {
    return {
      restrict: 'E',
      require: '^?tbSettingsCoordinator',
      template: '<tb:customization-settings props="props"/>',
      controller: CustomizationSettingsCtrl
    };
  }
);
